import { Injectable } from '@angular/core'
import { ISharedPagination } from '../../../models/interface/shared.interface'
import { Observable, of } from 'rxjs'
import { HttpClient, HttpParams } from '@angular/common/http'
import { AppConfigurationService } from '../../app-configuration.service'
import { SharedKey, SharedValue } from '../../../models/enum/shared.enum'
import { catchError, map, retry } from 'rxjs/operators'
import { CustomPaginationType } from '../../../features/shared/custom-components/custom-pagination/modals/enum/custom-pagination.enum'
import { SharedService } from '../../shared/shared.service'

@Injectable({
  providedIn: 'root'
})
export class DispenserShipmentService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private sharedService: SharedService
  ) {}

  public getShipments(code: string, params?: ISharedPagination): Observable<any> {
    let payload: HttpParams = new HttpParams().set(SharedKey.pageSize, SharedValue.pageSize.toString())

    if (params?.pageNumber) {
      payload = payload.set(SharedKey.currentPage, (params.pageNumber - 1).toString())
    }
    if (params?.status) {
      payload = payload.set(SharedKey.status, params.status)
    }
    if (params?.shipmentId) {
      payload = payload.set(SharedKey.shipmentId, params.shipmentId)
    }

    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/agreement/${code}/shipments`
    return this.http.get<any>(url, { params: payload }).pipe(
      map((res) => {
        if (res.results?.length) {
          res.results = res.results.map((item) => {
            if (item.orderDocumentsNumber?.length) {
              item.orderDocument = item.orderDocumentsNumber[0].documentNumber
            }
            return item
          })
        }
        res.pagination.type = CustomPaginationType.CUSTOM
        return res
      }),
      retry(1),
      catchError(() => {
        return of(null)
      })
    )
  }

  public getShipmentById(agreementCode: string, params: ISharedPagination): Observable<any> {
    return this.getShipments(agreementCode, params).pipe(
      map((res) => {
        if (res.results?.length) {
          return res.results[0]
        }
        return null
      })
    )
  }

  public getShipmentEntries(agreementCode: string, shipmentCode: string, params?: ISharedPagination): Observable<any> {
    let payload: HttpParams = new HttpParams().set(SharedKey.pageSize, SharedValue.pageSize.toString())

    if (params?.pageNumber) {
      payload = payload.set(SharedKey.currentPage, params.pageNumber.toString())
    }
    if (params?.status) {
      payload = payload.set(SharedKey.status, params.status)
    }
    if (params?.sku) {
      payload = payload.set(SharedKey.sku, params.sku)
    }

    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/agreement/${agreementCode}/shipments/${shipmentCode}`
    return this.http.get<any>(url, { params: payload }).pipe(
      map((res) => {
        res.pagination.type = CustomPaginationType.CUSTOM
        return res
      }),
      retry(1),
      catchError(this.sharedService.handleError)
    )
  }

  public downloadCSV(agreementCode: string): Observable<any> {
    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/agreement/${agreementCode}/shipments/shipmentCSV`
    return this.http.get<any>(url).pipe(
      map((res) => res.results),
      retry(1),
      catchError(() => {
        return of(null)
      })
    )
  }

  public downloadCSVEntries(agreementCode: string, shipmentCode: string): Observable<any> {
    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/agreement/${agreementCode}/shipments/${shipmentCode}/shipmentEntryCSV`
    return this.http.get<any>(url).pipe(
      map((res) => res.results),
      retry(1),
      catchError(() => {
        return of(null)
      })
    )
  }
}
